var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDisappointedC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 85.04C66.0031 85.04 85.04 66.0031 85.04 42.52C85.04 19.0369 66.0031 0 42.52 0C19.0369 0 0 19.0369 0 42.52C0 66.0031 19.0369 85.04 42.52 85.04Z",
    fill: "#FCC332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.29 53.48C66.04 53.48 65.79 53.43 65.55 53.34L56.74 49.82C55.97 49.51 55.47 48.77 55.48 47.94C55.48 47.11 56 46.38 56.78 46.09L65.59 42.79C66.63 42.41 67.78 42.93 68.17 43.96C68.56 44.99 68.03 46.15 67 46.54L63.03 48.03L67.05 49.64C68.08 50.05 68.57 51.21 68.16 52.24C67.85 53.02 67.1 53.5 66.3 53.5L66.29 53.48Z",
    fill: "#331100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 53.48C17.96 53.48 17.21 53 16.89 52.22C16.48 51.19 16.98 50.03 18 49.62L22.01 48.01L18.04 46.52C17.01 46.13 16.48 44.98 16.87 43.94C17.26 42.91 18.41 42.39 19.45 42.77L28.26 46.07C29.03 46.36 29.55 47.1 29.56 47.92C29.56 48.75 29.07 49.49 28.3 49.8L19.49 53.32C19.25 53.42 18.99 53.46 18.75 53.46V53.48Z",
    fill: "#331100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.16 63.52L63.03 54.64L57.9 63.52C57.4 64.39 57.11 65.4 57.11 66.47C57.11 69.74 59.76 72.39 63.03 72.39C66.3 72.39 68.95 69.74 68.95 66.47C68.95 65.39 68.66 64.39 68.16 63.52Z",
    fill: "#26B3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.47 62.36C50.86 62.36 50.29 61.99 50.06 61.38C48.89 58.24 45.85 56.13 42.51 56.13C39.17 56.13 36.13 58.24 34.96 61.38C34.67 62.16 33.8 62.55 33.03 62.26C32.25 61.97 31.86 61.11 32.15 60.33C33.76 56.02 37.92 53.13 42.51 53.13C47.1 53.13 51.26 56.02 52.87 60.33C53.16 61.11 52.77 61.97 51.99 62.26C51.82 62.32 51.64 62.35 51.47 62.35V62.36Z",
    fill: "#331100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisappointedC);
export default __webpack_public_path__ + "static/media/ic_disappointed_c.f3d1768b8c616f731eced655f799d0c0.svg";
export { ForwardRef as ReactComponent };